import { createFileRoute, useParams } from "@tanstack/react-router"
import IntakeResult from "@/pages/intakes/IntakeResult"
import { checkIntakeResultsEditable } from "@/utils/checkIntakeResultsEditable"
import { checkPermissions } from "@/utils/checkPermissions"
import { IntakeResultStepperContext } from "@/pages/intakes/intakeResultStepper"
import { useIntakeResultStore } from "@/stores/useIntakeResultStore"

export const Route = createFileRoute(
  "/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/",
)({
  component: RouteComponent,
  beforeLoad: async ({ context, params }) => {
    checkPermissions("read", "intake")

    await checkIntakeResultsEditable({
      queryClient: context.queryClient,
      intakeId: Number(params.intakeId),
    })
  },
})

function RouteComponent() {
  const { intakeId, studentId, studentProjectOrganizationId } = useParams({
    from: "/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/",
  })

  const { currentStep } = useIntakeResultStore()

  return (
    <IntakeResultStepperContext initialStep={currentStep}>
      <IntakeResult
        intakeId={Number(intakeId)}
        studentId={Number(studentId)}
        studentProjectOrganizationId={Number(studentProjectOrganizationId)}
        type="create"
      />
    </IntakeResultStepperContext>
  )
}
